module.exports =
{

  _init: function ()
  {
    APPLICATION._APPLICATION.processLinks('#plots', 'ONT', 'plots')
  }

}